import React from "react";
import styled from "styled-components";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { SvgIconWrapper } from "@sonder/ui/source/styled/fragments/SvgIconWrapper";
import { TagsToIcons } from "core/queries/GetTags";
import { AssigneePickerList } from "tasks/components/AssigneePicker.List";

const Label = styled.label`
  align-items: center;
  display: flex;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.75rem;
`;

const StyledIconWrapper = styled(SvgIconWrapper)`
  margin-right: 0.75rem;
`;

const StyledAccountCircle = styled(AccountCircle)`
  &&& {
    height: 1.8rem;
    margin-right: 0.75rem;
    width: 1.8rem;
  }
`;

interface AssigneePickerResult {
  itemId: string;
  nextAssigneeId: string | null;
}

interface AssigneePickerListWithSquadProps {
  assigneeIds: string[];
  className?: string;
  hasMultipleSupport?: boolean | null;
  isDisabled?: boolean;
  onSelect(result: AssigneePickerResult): void;
  squadTagName?: string;
  users: User[];
  usersWithMatchingSquad: User[];
}

export const AssigneePickerGroupList = ({
  assigneeIds,
  className,
  hasMultipleSupport,
  isDisabled,
  onSelect = () => undefined,
  squadTagName,
  users = [],
  usersWithMatchingSquad = [],
}: AssigneePickerListWithSquadProps) => {
  const TagIcon = squadTagName && TagsToIcons(squadTagName);

  return (
    <>
      {squadTagName && TagIcon && (
        <Label>
          <StyledIconWrapper>
            <TagIcon />
          </StyledIconWrapper>
          {squadTagName}
        </Label>
      )}
      <AssigneePickerList
        assigneeIds={assigneeIds}
        className={className}
        hasMultipleSupport={hasMultipleSupport}
        isDisabled={isDisabled}
        users={usersWithMatchingSquad}
        onSelect={onSelect}
      />
      <Label>
        <StyledAccountCircle />
        Team Members
      </Label>
      <AssigneePickerList
        assigneeIds={assigneeIds}
        className={className}
        hasMultipleSupport={hasMultipleSupport}
        isDisabled={isDisabled}
        users={users}
        onSelect={onSelect}
      />
    </>
  );
};
